export const userModule = {
    state: {
        roles: [],
        name: "",
        email: "",
    },

    mutations: {
        setRoles(state, roles) {
            state.roles = roles;
        },
        setName(state, name) {
            state.name = name;
        },
        setEmail(state, email) {
            state.email = email;
        },
    },

    actions: {
        saveRoles({ commit }, roles) {
            commit("setRoles", roles);
        },
        saveName({ commit }, name) {
            commit("setName", name);
        },
        saveEmail({ commit }, email) {
            commit("setEmail", email);
        },
    }
};